import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { get, set } from 'lodash'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  modalAction,
  authAction,
  leaveTypeAction,
  employeeAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  leaveTypeSelector,
  employeeSelector,
} from './../../selectors'
import { checkModifiedBy, searchLeaveType } from '../../function'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import LeaveTypeForm from '../../components/leave-type'
import LeaveTypeTable from '../../components/table-leave-type'

class LeaveTypePage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLeaveTypeData')) {
      set(tempState, 'leaveType', nextProps.getLeaveTypeData)
      set(tempState, 'defaultLeaveType', nextProps.getLeaveTypeData)
      nextProps.resetGetLeaveType()
    }
    if (nextProps.getLeaveTypeByIDData) {
      set(tempState, 'start_date', get(nextProps, 'getLeaveTypeByIDData.start_date'))
      set(tempState, 'end_date', get(nextProps, 'getLeaveTypeByIDData.end_date'))
      set(tempState, 'leave_type_code', get(nextProps, 'getLeaveTypeByIDData.leave_type_code'))
      set(tempState, 'name', get(nextProps, 'getLeaveTypeByIDData.name'))
      set(tempState, 'is_calendar_day', get(nextProps, 'getLeaveTypeByIDData.is_calendar_day'))
      set(tempState, 'is_probation_pass', get(nextProps, 'getLeaveTypeByIDData.is_probation_pass'))
      set(tempState, 'is_once', get(nextProps, 'getLeaveTypeByIDData.is_once'))
      set(tempState, 'is_deduct_leave_entitlment', get(nextProps, 'getLeaveTypeByIDData.is_deduct_leave_entitlment'))
      set(tempState, 'is_attachment', get(nextProps, 'getLeaveTypeByIDData.is_attachment'))
      set(tempState, 'is_hr_approve', get(nextProps, 'getLeaveTypeByIDData.is_hr_approve'))
      set(tempState, 'is_two_year_service_require', get(nextProps, 'getLeaveTypeByIDData.is_two_year_service_require'))
      set(tempState, 'is_maximum_days', get(nextProps, 'getLeaveTypeByIDData.max_days') > 0)
      set(tempState, 'max_days', get(nextProps, 'getLeaveTypeByIDData.max_days'))
      set(tempState, 'is_male', get(nextProps, 'getLeaveTypeByIDData.is_male'))
      set(tempState, 'is_female', get(nextProps, 'getLeaveTypeByIDData.is_female'))
      set(tempState, 'is_active', get(nextProps, 'getLeaveTypeByIDData.is_active'))
      set(tempState, 'updated', get(nextProps, 'getLeaveTypeByIDData.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'getLeaveTypeByIDData.updated_by'), prevState.employeeList))
      nextProps.resetGetLeaveTypeByID()
    }
    if (get(nextProps, 'createLeaveTypeData.createdLeaveType')) {
      const access_token = localStorage.getItem('access_token')
      const status = get(nextProps, 'createLeaveTypeData.status')
      const message = get(nextProps, 'createLeaveTypeData.message')
      if (status !== 200) {
        nextProps.showModal('leaveType', status, message)
      } else {
        nextProps.showConfirm('createSuccess', status, message)
      }
      nextProps.getLeaveType(access_token)
      nextProps.resetCreateLeaveType()
    }
    if (get(nextProps, 'editLeaveTypeData.updatedLeaveType')) {
      const access_token = localStorage.getItem('access_token')
      const status = get(nextProps, 'editLeaveTypeData.status')
      const message = get(nextProps, 'editLeaveTypeData.message')
      set(tempState, 'start_date', get(nextProps, 'editLeaveTypeData.updatedLeaveType.start_date'))
      set(tempState, 'end_date', get(nextProps, 'editLeaveTypeData.updatedLeaveType.end_date'))
      set(tempState, 'leave_type_code', get(nextProps, 'editLeaveTypeData.updatedLeaveType.leave_type_code'))
      set(tempState, 'name', get(nextProps, 'editLeaveTypeData.updatedLeaveType.name'))
      set(tempState, 'is_calendar_day', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_calendar_day'))
      set(tempState, 'is_probation_pass', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_probation_pass'))
      set(tempState, 'is_once', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_once'))
      set(tempState, 'is_deduct_leave_entitlment', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_deduct_leave_entitlment'))
      set(tempState, 'is_attachment', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_attachment'))
      set(tempState, 'is_hr_approve', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_hr_approve'))
      set(tempState, 'is_two_year_service_require', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_two_year_service_require'))
      set(tempState, 'is_maximum_days', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.max_days') > 0)
      set(tempState, 'max_days', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.max_days'))
      set(tempState, 'is_male', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_male'))
      set(tempState, 'is_female', get(nextProps, 'getLeaveTypeByIDData.updatedLeaveType.is_female'))
      set(tempState, 'is_active', get(nextProps, 'editLeaveTypeData.updatedLeaveType.is_active'))
      set(tempState, 'updated', get(nextProps, 'editLeaveTypeData.updatedLeaveType.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'editLeaveTypeData.updatedLeaveType.updated_by'), prevState.employeeList))
      set(tempState, 'isEdit', false)
      if (status !== 200) {
        nextProps.showModal('leaveType', status, message)
      } else {
        nextProps.showConfirm('editSuccess', status, message)
      }
      nextProps.getLeaveTypeByID(prevState.leaveTypeID, access_token)
      nextProps.getLeaveType(access_token)
      nextProps.resetEditLeaveType()
    }
    if (get(nextProps, 'deleteLeaveTypeData.deletedLeaveType')) {
      const access_token = localStorage.getItem('access_token')
      const status = get(nextProps, 'deleteLeaveTypeData.status')
      const message = get(nextProps, 'deleteLeaveTypeData.message')
      if (status !== 200) {
        nextProps.showModal('leaveType', status, message)
      } else {
        nextProps.showConfirm('deleteSuccess', status, message)
      }
      nextProps.getLeaveType(access_token)
      nextProps.resetDeleteLeaveType()
    }
    if (nextProps.getEmployeeData !== prevState.employeeList) {
      set(tempState, 'employeeList', nextProps.getEmployeeData)
    }
    if (nextProps.exportLeaveTypeData) {
      window.open(nextProps.exportLeaveTypeData, 'blank')
      nextProps.resetExportLeaveType()
    }
    return tempState
  }
  constructor(props) {
    super(props)
    this.state = {
      rowID: '',
      isSpan: false,
      isEdit: false,
      leaveTypeID: '',
      defaultLeaveType: [],
      leaveType: [],
      start_date: '',
      end_date: '',
      leave_type_code: '',
      name: '',
      is_calendar_day: false,
      is_probation_pass: false,
      is_once: false,
      is_deduct_leave_entitlment: false,
      is_attachment: false,
      is_male: false,
      is_female: false,
      is_hr_approve: false,
      is_two_year_service_require: false,
      is_maximum_days: false,
      max_days: 0,
      updated: '',
      updated_by: '',
      is_active: true,
      employeeList: [],
    }
    this.handleClickRow = this.handleClickRow.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }
  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getLeaveType(access_token)
    this.props.getEmployee(access_token)
  }
  handleInput(e) {
    if (e.target.type === 'checkbox') {
      this.setState({ [e.target.name]: e.target.checked })
    } else this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ isEdit: !this.state.isEdit })
  }
  handleClickRow(span, id, editID) {
    this.setState({
      isSpan: span,
      leaveTypeID: id,
      rowID: editID,
      isEdit: false,
    })
    if (span) {
      const access_token = localStorage.getItem('access_token')
      this.props.getLeaveTypeByID(id, access_token)
    }
  }
  handleClickSearch() {
    this.setState({
      leaveType: get(this.state, 'defaultLeaveType').filter(searchLeaveType, this.state.search),
    })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ leaveType: get(this.state, 'defaultLeaveType'), search: '' })
    else this.setState({ search: e.target.value })
  }
  showForm() {
    this.setState({
      start_date: '',
      end_date: '',
      leave_type_code: '',
      name: '',
      is_calendar_day: false,
      is_probation_pass: false,
      is_once: false,
      is_deduct_leave_entitlment: false,
      is_attachment: false,
      is_male: false,
      is_female: false,
      is_hr_approve: false,
      is_two_year_service_require: false,
      is_maximum_days: false,
      max_days: 0,
      is_active: true,
      isEdit: false,
      isSpan: false,
      leaveTypeID: '',
      rowID: '',
    })
    this.props.showModal('holidayForm')
  }
  cancelForm() {
    this.props.hideModal('holidayForm')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  handleDelete() {
    const access_token = localStorage.getItem('access_token')
    this.props.deleteLeaveType(this.state.leaveTypeID, access_token)
    this.handleClickRow(false, '', '')
    this.cancelDelete()
  }
  showDiscard() {
    if (this.state.isEdit) {
      this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
    } else this.handleClickRow(false, '', '')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  handleDiscard() {
    this.cancelDiscard()
    this.handleClickRow(false, '', '')
  }
  submitForm() {
    const payload = {
      start_date: this.state.start_date ? moment(this.state.start_date) : '',
      end_date: this.state.end_date ? moment(this.state.end_date) : '',
      leave_type_code: this.state.leave_type_code,
      name: this.state.name,
      is_calendar_day: this.state.is_calendar_day,
      is_probation_pass: this.state.is_probation_pass,
      is_once: this.state.is_once,
      is_deduct_leave_entitlment: this.state.is_deduct_leave_entitlment,
      is_attachment: this.state.is_attachment,
      is_male: this.state.is_male,
      is_female: this.state.is_female,
      is_hr_approve: this.state.is_hr_approve,
      is_two_year_service_require: this.state.is_two_year_service_require,
      max_days: this.state.is_maximum_days && this.state.max_days > 0 ? this.state.max_days : 0,
      is_active: this.state.is_active,
    }
    const access_token = localStorage.getItem('access_token')
    if (this.state.isEdit) {
      delete payload.leave_total_default
      this.props.editLeaveType(this.state.leaveTypeID, payload, access_token)
    } else this.props.createLeaveType(payload, access_token)
    this.cancelForm()
  }
  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectLeaveType.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectLeaveType.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'
 
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.isEdit ? this.submitForm : this.handleClickEdit }>{ this.state.isEdit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonOK = (type) => (
      <div>
        <NewButton color="success" onClick={ () => this.props.hideConfirm(type) }>OK</NewButton>
      </div>
    )
    const buttonCreate = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingLeaveType')
    || get(this.props, 'getIsFetchingEmployee')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          toggleCreate={ this.showForm }
          // export={ () => this.props.exportLeaveType(localStorage.getItem('access_token')) }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          get(this.props, 'modalType') === 'leaveType' &&
            <CustomModal
              hide={ () => this.props.hideModal('leaveType') }
              show={ get(this.props, 'modalType') === 'leaveType' }
              type={ get(this.props, 'modalStatus') }
              message={ get(this.props, 'modalMessage') }
            />
        }
        <Row noGutters>
          {
            get(this.props, 'confirmType') === 'createSuccess' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm('createSuccess') }
              show={ get(this.props, 'confirmType') === 'createSuccess' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ buttonOK('createSuccess') }
            />
          }
          {
            get(this.props, 'confirmType') === 'editSuccess' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm('editSuccess') }
              show={ get(this.props, 'confirmType') === 'editSuccess' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ buttonOK('editSuccess') }
            />
          }
          {
            get(this.props, 'confirmType') === 'deleteSuccess' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm('deleteSuccess') }
              show={ get(this.props, 'confirmType') === 'deleteSuccess' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ buttonOK('deleteSuccess') }
            />
          }
          { get(this.props, 'confirmType') === 'confirmDiscard' &&
          <CustomModalMessage
            hide={ this.cancelDiscard }
            show={ get(this.props, 'confirmType') === 'confirmDiscard' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDiscard }
          />
          }
          { get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.cancelDelete }
            show={ get(this.props, 'confirmType') === 'confirmDelete' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
          }
          <Row noGutters>
            <Col>
              <LeaveTypeTable
                handleInput={ this.handleInput }
                handleClickRow={ this.handleClickRow }
                { ...this.state }
              />
            </Col>
            {
              this.state.isSpan &&
              <Col>
                <LeaveTypeForm
                  handleInput={ this.handleInput }
                  button={ button }
                  { ...this.state }
                  handleClickRow={ this.handleClickRow }
                  cancelForm={ this.cancelForm }
                  showDelete={ this.showDelete }
                  cancelDelete={ this.cancelDelete }
                  showDiscard={ this.showDiscard }
                  cancelDiscard={ this.cancelDiscard }
                />
              </Col>
            }
          </Row>
          {
            <Modal isOpen={ get(this.props, 'modalType') === 'holidayForm' } toggle={ this.cancelForm }>
              <LeaveTypeForm
                create={ true }
                button={ buttonCreate }
                { ...this.state }
                handleInput={ this.handleInput }
                cancelForm={ this.cancelForm }
              />
            </Modal>
          }
        </Row>
      </Wrapper>
    )
  }
}
LeaveTypePage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  getLeaveType: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getLeaveTypeByID: PropTypes.func.isRequired,
  editLeaveType: PropTypes.func.isRequired,
  createLeaveType: PropTypes.func.isRequired,
  deleteLeaveType: PropTypes.func.isRequired,
  exportLeaveType: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectLeaveType: leaveTypeSelector.redirectLeaveType,
  getIsFetchingLeaveType: leaveTypeSelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getLeaveTypeData: leaveTypeSelector.getLeaveTypeData,
  getLeaveTypeByIDData: leaveTypeSelector.getLeaveTypeByIDData,
  editLeaveTypeData: leaveTypeSelector.editLeaveTypeData,
  createLeaveTypeData: leaveTypeSelector.createLeaveTypeData,
  deleteLeaveTypeData: leaveTypeSelector.deleteLeaveTypeData,
  exportLeaveTypeData: leaveTypeSelector.getExportURL,
  getEmployeeData: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getLeaveType: leaveTypeAction.getLeaveType,
  resetGetLeaveType: leaveTypeAction.resetGetLeaveType,
  getLeaveTypeByID: leaveTypeAction.getLeaveTypeByID,
  resetGetLeaveTypeByID: leaveTypeAction.resetGetLeaveTypeByID,
  editLeaveType: leaveTypeAction.editLeaveType,
  resetEditLeaveType: leaveTypeAction.resetEditLeaveType,
  createLeaveType: leaveTypeAction.createLeaveType,
  resetCreateLeaveType: leaveTypeAction.resetCreateLeaveType,
  deleteLeaveType: leaveTypeAction.deleteLeaveType,
  resetDeleteLeaveType: leaveTypeAction.resetDeleteLeaveType,
  exportLeaveType: leaveTypeAction.exportLeaveType,
  resetExportLeaveType: leaveTypeAction.resetExportLeaveType,
  getEmployee: employeeAction.getUser,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(LeaveTypePage))
const Wrapper = styled(Container)`
  padding: 0px;
  backgroundColor: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/leave-type/index.js